import React from 'react';
import PropTypes from 'prop-types';

import Kinostyles from '../../Util/LandingPageStylesComponent.module.css';

const TextBlock = props => {
  const { text, lines, centered } = props;

  const textContent = () => {
    console.log(lines);
    if (lines && lines.length > 0) {
      return lines.map(line => (
        <>
          {line}
          <br />
        </>
      ));
    } else {
      return <div dangerouslySetInnerHTML={{ __html: text }}></div>;
    }
  };

  return (
    <div>
      {centered ? (
        <div
          className={Kinostyles.TextContainer + ' ' + Kinostyles.CenterContent}
        >
          {textContent()}
        </div>
      ) : (
        <div className={Kinostyles.TextContainer}>{textContent()}</div>
      )}
    </div>
  );
};

TextBlock.propTypes = {
  text: PropTypes.string,
  lines: PropTypes.array,
  centered: PropTypes.bool,
};

export default TextBlock;
